<span class="tui-text_body-m">{{ title }}</span>

<tui-badge *ngIf="count > 0" appearance="primary" size="m">{{ count }}</tui-badge>
